import { render, staticRenderFns } from "./QuestionBody.vue?vue&type=template&id=53415294&%3Akey=questionKey"
import script from "./QuestionBody.vue?vue&type=script&lang=ts"
export * from "./QuestionBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports